import { lazyWithRetry } from '@tyro/core';
import { MobileIcon } from '@tyro/icons';
import { type NavObjectFunction, NavObjectType } from '@tyro/router/types';
import { getSentSms } from './api/sent-sms';
import { getSmsBalance } from './api/sms-balance';

const Sms = lazyWithRetry(() => import('./pages/index'));

export const getRoutes: NavObjectFunction = (t) => [
  {
    type: NavObjectType.Category,
    title: t('navigation:management.title'),
    children: [
      {
        type: NavObjectType.RootLink,
        path: '/sms',
        hasAccess: ({ permissions }) =>
          permissions.isStaffUserWithPermission(
            'ps:1:communications:read_sms_receipts',
          ),
        title: t('navigation:management.sms'),
        icon: <MobileIcon />,
        element: <Sms />,
        loader: () => Promise.all([getSentSms({ ids: [] }), getSmsBalance()]),
      },
    ],
  },
];
